import { useState, useRef } from "react";
import "../styles/Faq.css";

function Faq() {
  const [openQuestion, setOpenQuestion] = useState(null);
  const answerRefs = useRef([]);

  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  const faqData = [
    {
      question: "Who can attend?",
      answer: `For both QREATE & QOMPUTE, virtual participation is available to all. However, for in-person participation, anyone can attend QREATE but we are 
        capacity restricted to 300 participants max. Please be aware that we may not be able to record 
        all performances at QREATE. In-person attendance at QREATE is heavily encouraged. In-person participation at QOMPUTE is only available to USC students. `,
    },
    {
      question: "Is Q<sup>3</sup> a traditional hackathon?",
      answer: `Yes and no. QOMPUTE @ USC will be a traditional 24-hour hackathon on September 12-14. The QOMPUTE challenges will be more technical sponsored quantum 
        computing challenges. QREATE @ UMD is a non-traditional, fully virtual, 4 week hackathon focused on creating art (animations, music, etc) to help teach 
        quantum to the general public. The challenges for the UMD side will open on September 12 and close October 10.`,
    },
    /*{
      question: "Where can I find the Quantum x Art challenges?",
      answer: `You can find these challenges and submit your project on the DoraHacks site.`,
    }*/
    {
      question: "Will there be prizes?",
      answer: `Yes! There will be cash prizes and even opportunities to get hired!`,
    },
    {
      question: "How many people per team?",
      answer: `We suggest teams of 2-4 people.`,
    },
    {
      question:
        "For the Quantum x Art challenges, why is the team required to have at least one artist?",
      answer: `There is no Quantum x Art without the art! Artists will challenge scientists to communicate complex quantum topics in a
         manner that is understandable by someone without a strong scientific background. Teams without at least one artist will be disqualified.`,
    },
    {
      question: "When will projects be judged?",
      answer: `QOMPUTE projects will be judged on Sunday, September 14 and winners will be announced later that evening. QREATE winners will be 
        announced at the Quantum Career Leap Nexus on October 29.`,
    },
    {
      question: "Where will QREATE be held?",
      answer: `QREATE @ UMD will be held in the Hoff Theatre on September 12 and the Colony Ballroom on September 13. Please keep in mind the parking restrictions on September 13 due to the football game. We highly suggest parking in Mowatt Garage for September 13.`,
    },
  ];

  return (
    <div className="faq-container">
      <h1>FAQ</h1>
      <div className="faq-content">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <h3
              className="faq-question"
              onClick={() => toggleQuestion(index)}
              dangerouslySetInnerHTML={{ __html: item.question }}
            />
            <div
              className={`faq-answer-wrapper ${
                openQuestion === index ? "open" : ""
              }`}
              style={{
                height:
                  openQuestion === index
                    ? answerRefs.current[index]?.scrollHeight + "px"
                    : "0px",
              }}
              ref={(el) => (answerRefs.current[index] = el)}
            >
              <p
                className="faq-answer"
                dangerouslySetInnerHTML={{ __html: item.answer }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Faq;